import { ESteps } from '~/src/features/full-buy/types';
import { getABNVariant } from '~/src/helpers/abn-tests';

export const isConnectionCostHidden = (step: ESteps | undefined, isApartmentPackage: boolean) => {
    return getABNVariant('full_buy_hide_connection_cost') === 'hide_connection_cost' && !(step === ESteps.timeSlots || step === ESteps.final) && isApartmentPackage;
};

export const isConnectionCostByVisitShown = (isApartmentPackage: boolean) => {
    return getABNVariant('full_buy_hide_connection_cost') === 'hide_connection_cost' && isApartmentPackage;
};
